const Videos = [
    // {
    //     id: 1,
    //     name: "Powerful Zodiac 2019",
    //     preview: "https://cdn.mobiotv.com/bidiotv/Brain+Boost/Powerful+zodiac+2019.jpg",
    //     videourl: "https://cdn.mobiotv.com/bidiotv/Brain+Boost/Powerful+zodiac+2019.mp4",
    // },
    {
        id: 2,
        name: "Channeled message from your spirit guides",
        preview: "https://cdn.mobiotv.com/bidiotv/Astrology/Channeled+message+from+your+spirit+guides.jpg",
        videourl: "https://cdn.mobiotv.com/bidiotv/Astrology/Channeled+message+from+your+spirit+guides.mp4",
    },
    {

        id: 3,
        name: "HOW & WHEN You Will You Become SUCCESSFUL",
        preview: "https://cdn.mobiotv.com/bidiotv/Astrology/HOW+%26+WHEN+You+Will+You+Become+SUCCESSFUL.jpg",

        videourl: "https://cdn.mobiotv.com/bidiotv/Astrology/HOW+%26+WHEN+You+Will+You+Become+SUCCESSFUL.mp4",

    },
    {

        id: 4,
        name: "How do people you date-dated see you",
        preview: "https://cdn.mobiotv.com/bidiotv/Astrology/How+do+people+you+date-dated+see+you.jpg",

        videourl: "https://cdn.mobiotv.com/bidiotv/Astrology/How+do+people+you+date-dated+see+you.mp4",

    },
    {
        id: 5,
        name: "Pick a card - Are they secretly thinking about you",
        preview: "https://cdn.mobiotv.com/bidiotv/Astrology/Pick+A+Card+-+What+Do+They+Secretly+Want+to+Tell+You.jpg",
        videourl: "https://cdn.mobiotv.com/bidiotv/Astrology/Pick+A+Card+-+What+Do+They+Secretly+Want+to+Tell+You.mp4",
    },
    {
        id: 6,
        name: "Pick A Card - What Do They Secretly Want to Tell You",
        preview: "https://cdn.mobiotv.com/bidiotv/Astrology/Pick+a+card+-+Are+they+secretly+thinking+about+you.jpg",
        videourl: "https://cdn.mobiotv.com/bidiotv/Astrology/Pick+a+card+-+Are+they+secretly+thinking+about+you.mp4",
    },
    // {
    //     id: 7,
    //     name: "What’s Coming for You in 2019",
    //     preview: "https://cdn.mobiotv.com/bidiotv/Astrology/What%E2%80%99s+Coming+for+You+in+2019.jpg",
    //     videourl: "https://cdn.mobiotv.com/bidiotv/Astrology/What%E2%80%99s+Coming+for+You+in+2019.mp4",
    // },
    {
        id: 8,
        name: "Why do they act like this What's going on with them",
        preview: "https://cdn.mobiotv.com/bidiotv/Astrology/Why+do+they+act+like+this+What's+going+on+with+them.jpg",
        videourl: "https://cdn.mobiotv.com/bidiotv/Astrology/Why+do+they+act+like+this+What's+going+on+with+them.mp4",
    },
    {
        id: 9,
        name: "September Predictions for All 12 Signs",
        preview: "https://cdn.mobiotv.com/bidiotv/Astrology/September+Predictions+for+All+12+Signs.jpeg",
        videourl: "https://cdn.mobiotv.com/bidiotv/Astrology/September+Predictions+for+All+12+Signs.mp4"
    },
    {
        id: 10,
        name: "September 2022 Predictions Major Cover-Ups Revealed!",
        preview: "https://cdn.mobiotv.com/bidiotv/Astrology/September+2022+Predictions+Major+Cover-Ups+Revealed!.jpeg",
        videourl: "https://cdn.mobiotv.com/bidiotv/Astrology/September+2022+Predictions+Major+Cover-Ups+Revealed!.mp4"
    },
    {
        id: 11,
        name: "2022 Prediction For Each Zodiac Sign",
        preview: "https://cdn.mobiotv.com/bidiotv/Astrology/2022+Prediction+For+Each+Zodiac+Sign.jpeg",
        videourl: "https://cdn.mobiotv.com/bidiotv/Astrology/2022+Prediction+For+Each+Zodiac+Sign.mp4"
    },
    {
        id: 12,
        name: "A Matter of Choice' - Libra Equinox Preview with Astrologer and Author Pam Gregory & Davyd Farrell",
        preview: "https://cdn.mobiotv.com/bidiotv/Astrology/'A+Matter+of+Choice'+-+Libra+Equinox+Preview+with+Astrologer+and+Author+Pam+Gregory+%26+Davyd+Farrell.jpeg",
        videourl: "https://cdn.mobiotv.com/bidiotv/Astrology/'A+Matter+of+Choice'+-+Libra+Equinox+Preview+with+Astrologer+and+Author+Pam+Gregory+%26+Davyd+Farrell.mp4"
    },
    {
        id: 13,
        name: "September 2022 Astrology Prediction Monthly Astrology Forecast",
        preview: "https://cdn.mobiotv.com/bidiotv/Astrology/September+2022+Astrology+Prediction+Monthly+Astrology+Forecast.jpeg",
        videourl: "https://cdn.mobiotv.com/bidiotv/Astrology/September+2022+Astrology+Prediction+Monthly+Astrology+Forecast.mp4"
    }
]

export default Videos;


// WEBPACK FOOTER //
// ./src/mobioastro/components/screens/Astrovideos/Astrovideolist.js